export enum TipoTarifacaoEnum {
    SemTaxas = 1,
    EmDiaEspecifico = 2,
    DiaDaTransacao = 3,
    DiaSeguinte = 4,
    DiaDoPagamento = 5
}
